// extracted by mini-css-extract-plugin
export default {"formLabel":"FormLabel-module__formLabel___wfAby","required":"FormLabel-module__required___RlLrf"};